<div class="banner clearfix">
  <div class="banner-area"
  [class.d-none]="(!data['images'] || !data['images'][0]) && editable"
  [style.opacity]="data['images'] && data['images'][0] && isBannerImageLoaded ? 1 : 0">
    <!-- 前台畫面放這裡面 -->
    <ng-container *ngFor="let image of data['images']">
      <ng-container *ngIf="image.url">
        <img src="{{image | transform: 'detail'}}" alt="{{image.name}}" width="auto" height="auto" border="0"
        tmErrorDefaultImage="/assets/images/no-pic.webp"
        style="width: 100%;"
        (load)="isBannerImageLoaded = true" #previewImg/>
      </ng-container>
    </ng-container>
    <!-- /前台畫面放這裡面 -->

    <div class="upload-section-toolkit" *ngIf="editable">
      <button class="btn btn-light" (click)="fileInput?.click()"><i class="fa fa-upload" aria-hidden="true"></i>上傳圖像</button>
      <button class="btn btn-light" (click)="deleteFile($event, data['images'][0])"><i class="fa fa-trash" aria-hidden="true"></i>移除圖像</button>
    </div>
  </div>

  <div class="qq-uploader-selector qq-uploader qq-gallery" *ngIf="editable" [class.d-none]="data['images'] && data['images'][0] && isBannerImageLoaded">
    <div class="upload-section" [class.d-none]="data['images'].length > 0">
      <h3>主題代表圖像</h3>
      <div class="upload-section-row">
        <input type="file" class="d-none" [disabled]="!uploadSetting" (change)="fileInputOnChange($event)" #fileInput>
        <button class="btn btn-light" (click)="fileInput?.click()">選擇檔案</button>
        <span style="margin: 0 20px;">或</span><span>將檔案拖曳至此處</span>
      </div>
      <div class="upload-section-row" *ngIf="uploadSetting">
        <p>上傳格式：<span>{{uploadSetting.ext}}</span> 建議尺寸：<span>1920 X 900</span> 檔案大小：<span>{{sizeDetacted('MB', uploadSetting.byte)}}MB</span>以內</p>
      </div>
    </div>
    
    <ul class="qq-upload-list">
      <li class="qq-upload-list-selector" *ngFor="let file of data['images']; let i = index" (click)="$event.stopPropagation();">
        <!-- <ng-container *ngIf="file.fileid">
          <div class="qq-thumbnail-wrapper">
            <a target="_blank" href="{{file.url}}" *ngIf="!isCanDragPos">
              <img class="qq-thumbnail-selector" [src]="file.url">
            </a>

            <img class="qq-thumbnail-selector" [src]="file.url" *ngIf="isCanDragPos"
            tmDragPosition [initData]="data['elSetting']" [onlyYAxis]="true"
            (dpDataInit)="setDraggableDataSetting($event, i)">
          </div>

          <div class="qq-file-info">
            <div class="upload-section-toolkit" *ngIf="data['images'] && data['images'][0] && editable">
              <button class="btn btn-light" (click)="fileInput.click()"><i class="fa fa-upload" aria-hidden="true"></i>上傳圖像</button>
              <button class="btn btn-light" [class.active]="isCanDragPos" (click)="isCanDragPos = !isCanDragPos" title="{{isCanDragPos ? '再點一下結束調整' : ''}}"><i class="fa fa-arrows" aria-hidden="true"></i>調整位置</button>
              <button class="btn btn-light" (click)="deleteFile($event, data['images'][0])"><i class="fa fa-trash" aria-hidden="true"></i>移除圖像</button>
            </div>
          </div>
        </ng-container> -->

        <ng-container *ngIf="!file.id">
          <div class="qq-thumbnail-wrapper">
            <img class="qq-thumbnail-selector" [src]="file['previewImgUrl'] || ''">
          </div>
          <div class="qq-file-info">
            <ng-container *ngIf="file.progress > 0">
              <div class="progress form-group">
                <div class="progress-bar progress-bar-striped bg-success" role="progressbar" [style.width.%]="file.progress"></div>
              </div>
            </ng-container>
          </div>
        </ng-container>
      </li>
    </ul>
  </div>
</div>
